import { useTranslation } from 'react-i18next'

/**
 * Date formatting utilities for bilingual support
 * US format: MM/DD/YYYY
 * Latin America format: DD/MM/YYYY
 */

export const formatDate = (date, language = 'en') => {
  if (!date) return ''
  
  const dateObj = new Date(date)
  if (isNaN(dateObj)) return ''

  // Use browser locale based on language
  const locale = language === 'es' ? 'es-ES' : 'en-US'
  
  return dateObj.toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export const formatDateTime = (date, language = 'en') => {
  if (!date) return ''
  
  const dateObj = new Date(date)
  if (isNaN(dateObj)) return ''

  const locale = language === 'es' ? 'es-ES' : 'en-US'
  
  return dateObj.toLocaleDateString(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const capitalizeMonthLabel = (label, locale) =>
  label.charAt(0).toLocaleUpperCase(locale) + label.slice(1)

export const formatMonthYear = (month, year, language = 'en') => {
  const date = new Date(year, month - 1, 1)
  const locale = language === 'es' ? 'es-ES' : 'en-US'

  return capitalizeMonthLabel(date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long'
  }), locale)
}

export const formatShortMonth = (month, language = 'en') => {
  const date = new Date(2024, month - 1, 1)
  const locale = language === 'es' ? 'es-ES' : 'en-US'
  
  return capitalizeMonthLabel(date.toLocaleDateString(locale, {
    month: 'short'
  }), locale)
}

// Hook for easy date formatting within components
export const useDateFormatter = () => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language
  
  return {
    formatDate: (date) => formatDate(date, currentLanguage),
    formatDateTime: (date) => formatDateTime(date, currentLanguage),
    formatMonthYear: (month, year) => formatMonthYear(month, year, currentLanguage),
    formatShortMonth: (month) => formatShortMonth(month, currentLanguage),
    currentLanguage
  }
}

const dateFormatter = {
  formatDate,
  formatDateTime,
  formatMonthYear,
  formatShortMonth,
  useDateFormatter
}

export default dateFormatter
